import { Component, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@lib/services/auth-service.service';
import { QueryManagerService } from '@lib/services/queryManagerService';
import { gql } from 'apollo-angular';
import { OuiBannerAction } from 'omnium-ui/banner';
import { OuiDialogService } from 'omnium-ui/dialog';
import { OuiTabGroup } from 'omnium-ui/tabs';
import {
  CreationPersonneMorale,
  Investisseur,
  InvestisseurType,
} from 'projects/box-lib/src/lib/models/generated/graphql';
import { firstValueFrom, Subscription } from 'rxjs';
import { DraftOperationsService } from 'src/service/draft-operation/draft-operation.service';
import { CREATION_PM_TAB_KEY, OperationTabsService } from 'src/service/operation-tabs.service';
import { NoneActiveHabilitationMessageComponent } from '../none-active-habilitation-message/none-active-habilitation-message.component';
import { CreationPMTab, OperationTab } from './consultant-tab';
const INVESTISSEUR_BY_ID = gql`
  query investisseurById($id: Long!) {
    investisseurById(id: $id) {
      id
      code
      ppeBackOffice
      gdaBackOffice
      investisseurEntite {
        displayName
        type
      }
    }
  }
`;
@Component({
    selector: 'app-my-operations',
    templateUrl: './my-operations.component.html',
    styleUrls: ['./my-operations.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MyOperationsComponent {
  @ViewChild(OuiTabGroup) tabGroup: OuiTabGroup;
  toTreatItemNumber: string = '';
  waitingItemNumber: string = '';
  historyItemNumber: string = '';
  creationPMItemNumber: string = '';

  noHabilAction: OuiBannerAction = {
    label: 'En savoir plus',
    action: () => {
      this.openHabilitationMessage();
    },
  };

  isNotHabilitedWarning: boolean = false;
  userHabilitationCheckSubscription: Subscription;

  constructor(
    private router: Router,
    private draftOperationService: DraftOperationsService,
    private authService: AuthService,
    private dialogService: OuiDialogService,
    private queryManager: QueryManagerService,
    protected tabService: OperationTabsService
  ) {}

  ngOnInit() {
    this.tabService.initAndSetTabs();
    this.userHabilitationCheckSubscription = this.authService.userHabilitationCheck.subscribe(value => {
      if (value) {
        this.isNotHabilitedWarning = !this.authService.isAnyHabilitationValid();
      }
    });
    //this.setTabs();
  }
  ngAfterViewInit() {}
  ngOnDestroy() {
    if (this.userHabilitationCheckSubscription) {
      this.userHabilitationCheckSubscription.unsubscribe();
    }
  }
  onDeclareSubsButtonClick() {
    this.draftOperationService.reset();
    this.router.navigate(['souscription']);
  }

  onDeclareActeButtonClick() {
    this.draftOperationService.reset();
    this.router.navigate(['actes']);
  }

  isAuth(): boolean {
    return this.authService.isAuthenticated();
  }
  openHabilitationMessage() {
    this.dialogService.openDialog(
      NoneActiveHabilitationMessageComponent,
      {
        title: 'Aucune habilitation active',
      },
      'auto',
      '662px'
    );
  }

  isCreationTab(tab: CreationPMTab | OperationTab): tab is CreationPMTab {
    return tab.template === 'creation';
  }

  isOperationTab(tab: CreationPMTab | OperationTab): tab is OperationTab {
    return tab.template === 'operation';
  }

  goToCreationPM() {
    this.router.navigate(['operations', CREATION_PM_TAB_KEY]);
  }

  async onDeclareSouscriptionFromCreationPM(creationPM: CreationPersonneMorale) {
    this.draftOperationService.reset();
    if (creationPM.atlasInvestisseurId) {
      const result = await firstValueFrom(
        this.queryManager.query<{ investisseurById: Investisseur }>({
          query: INVESTISSEUR_BY_ID,
          variables: {
            id: creationPM.atlasInvestisseurId,
          },
        })
      );

      if (result?.data?.investisseurById) {
        this.draftOperationService.reset();
        this.draftOperationService.investisseur = result.data.investisseurById;
        this.draftOperationService.investisseurType = InvestisseurType.PersonneMorale;
        this.router.navigate(['souscription']);
      }
    }
  }
}
